<template lang="pug">
  v-flex 
    v-card
      v-card-title Documentos
        v-spacer
        v-text-field(v-model='search' append-icon='fa-search' label='Buscar documento' single-line hide-details)
        v-dialog(v-model='$store.state.Documents.dialog' max-width='500px')
          template(v-slot:activator='{ on }')
            v-btn.mb-2(color='primary' dark v-on='on' @click='cleanSelectedKey()') Añadir
          v-card
            v-card-title
              span.headline Añadir
            v-card-text
              v-form( autocomplete='false' v-model='valid')
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(:rules='[$store.state.Helpers.rules.required]' v-model='$store.state.Documents.data.name' label='Comprobante de pago')
                    v-flex(xs12)
                      v-text-field(:rules='[$store.state.Helpers.rules.required]' v-model='$store.state.Documents.data.code' label='Código')
                    v-flex(xs12)
                      v-text-field(label='Agregar serie' append-icon='fas fa-plus' v-model='serialNumberToAdd' @click:append="addSerialNumber(serialNumberToAdd)")
                      
                      v-data-table( v-if='$store.state.Documents.data.serialNumbers && $store.state.Documents.data.serialNumbers.length>0' hide-default-footer :headers="[{text:'Nombre', value:'name'}, {text:'Numeración', value:'numeration'}, {text:'', value:''}]" :items="$store.state.Documents.data.serialNumbers")
                        template( v-slot:items="props")
                          td {{ props.item.name }}
                          td 
                            v-text-field(type='number' v-model='props.item.numeration')
                          td 
                            v-btn(color='primary' icon @click='deleteSerialNumber(props.index)')
                              v-icon far fa-trash-alt
                    v-flex(xs12)
                      h4 Configuración
                      v-switch(color='primary' v-model='$store.state.Documents.data.haveIGV' label='Tiene campos de IGV')
                      v-switch(color='primary' v-model='$store.state.Documents.data.isInputCategory' label='Se utiliza en operaciones de entrada')
                      v-switch(color='primary' v-model='$store.state.Documents.data.isOutputCategory' label='Se utiliza en operaciones de salida')
                      v-switch(color='primary' @change='addSerialNumberDefault($store.state.Documents.data.isInputDefaultDocument)' v-model='$store.state.Documents.data.isInputDefaultDocument' label='Documento por defecto de Entradas')
                      v-switch(color='primary' @change='addSerialNumberDefault($store.state.Documents.data.isOutputDefaultDocument)' v-model='$store.state.Documents.data.isOutputDefaultDocument' label='Documento por defecto de Salidas')
            v-card-actions
              v-spacer
              v-btn(color='primary' @click='$store.state.Documents.dialog = false') Cancelar
              v-btn(color='primary' :disabled='!valid' @click='(valid) ? save() : null') Guardar
      v-data-table.elevation-1(:headers='headers' :items='record' :footer-props="footerProps" :search='search')
        template(v-slot:items='props')
          td {{ props.item.name }}
          td 
            v-icon.mr-1(color='primary' v-if='props.item.haveIGV') fa-percentage
            v-icon.mr-1(color='primary' v-if='props.item.isInputCategory') fa-sign-in-alt
            v-icon.mr-1(color='primary' v-if='props.item.isOutputCategory') fa-sign-out-alt
            v-icon.mr-1(color='primary' v-if='props.item.isInputDefaultDocument') fa-file-upload
            v-icon.mr-1(color='primary' v-if='props.item.isOutputDefaultDocument') fa-file-download
          td
            template(v-for='item in props.item.serialNumbers' )
              v-chip {{item.name}}
          td.justify-center.layout.px-0
            v-btn(color='secondary' icon @click='editItem(props.item.key)')
              v-icon(small) far fa-edit
            v-btn(color='secondary' icon @click='deleteItem(props.item.key)')
              v-icon(small) far fa-trash-alt
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  data: () => ({
    search: '',
    valid: true,
    headers: [
      {
        text: 'Tipo de recibo',
        align: 'left',
        value: 'name'
      },
      { text: 'Configuración', value: 'setting' },
      
      { text: 'Números de serie', value: 'serialNumbers' },

      { text: 'Acciones', value: ''}
    ],
    editedIndex: -1,
    serialNumberToAdd: '',
    serialNumbers:[],
    footerProps: {
      'items-per-page-options':   [15, 30, 50]
    }
    }),
    methods: {     
     
      ...mapActions({
        editItem: 'Documents/get',
        deleteItem: 'Documents/clean',
        save: 'Documents/add',
        cleanSelectedKey: 'Documents/cleanForm'
      }),
      addSerialNumber(name){
        if(name!='') this.$store.state.Documents.data.serialNumbers.push({name: String(name).padStart(4,0), numeration: 0})
        this.serialNumberToAdd=''
      },
      deleteSerialNumber(index){
        this.$store.state.Documents.data.serialNumbers.splice(index, 1)
      },
      addSerialNumberDefault(state){
        let indexIfSerialNumberDefaultExist = this.$store.state.Documents.data.serialNumbers.findIndex((item, index) => item.name == 'Por defecto')
        if( indexIfSerialNumberDefaultExist > -1 && state){
          return
        } else if( indexIfSerialNumberDefaultExist == -1 && state) {
          this.$store.state.Documents.data.serialNumbers.push({name: 'Por defecto', numeration: 0})
        } else if (indexIfSerialNumberDefaultExist > -1 || !state){
          this.$store.state.Documents.data.serialNumbers.splice(indexIfSerialNumberDefaultExist, 1)
        }
      }
    },
    computed: {
      ...mapGetters({
        record: 'Documents/record',
      })
    },
    watch:{
    
    }
  }
</script>
